import { ApplicationCode } from "constants/auth";

import Authorization from "features/authorization/Authorization";

import { RequestDetailComponent } from "../components/RequestDetail";

export const RequestDetail = () => {
  return (
    <Authorization permission={[ApplicationCode.Request]}>
      <RequestDetailComponent />
    </Authorization>
  );
};
